import React, { useState } from "react";
import RequestService from "../../services/request.service";

import { toast } from 'react-toastify'

import moment from 'moment'
import 'moment/locale/es'


import { labelType } from '../../features/interfaces'


import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';


import Select from 'react-select';

import { labelTipoReporteAuditoria } from '../../services/funcionesPublicas'

const ReportesPersonal = () =>{

      const [ reporte, setRegistro ] = useState<any>({
        acumulado_tipo_movimiento : [],
        acumulado_empleados : [],
        listado_movimientos_empleados : [],
      })

      const cargarMiReporte = async () =>{
        try{
          setCargando(true)
            let uuids_sucursales = etiquetas_seleccionadas.map( (sucursal:any)=> sucursal.value )
            var ED = endDate ? moment(endDate).format('YYYY-MM-DD') : null
            let res = await RequestService.getEndPointPost(`reportes/movimientos/${moment(startDate).format('YYYY-MM-DD')}/${ED}`,{ sucursales : uuids_sucursales })
          setCargando(false)
            setRegistro(res.data)

        }
        catch(e){
          setCargando(false)
          toast.error('Problemas cargando')
          toast.error(JSON.stringify(e))
        }
      }



  const [ sucursales, setSucursales ] = useState<any>([])
  const cargarSucursales = async()=>{
    try{
      
      let response : any = await RequestService.getEndPoint('sucursales')
      // let suc : any = response.data
      let sucursales : any = response.data.map( sucursal =>{ return  { value :  sucursal.uuid, label : sucursal.nombre_sucursal } })
      setSucursales(sucursales)
    }
    catch(e){
      toast.error('Problemas al intentar cargar sucursales')
    }
  }


      React.useEffect(() => {
        cargarMiReporte()
        cargarSucursales()
      }, []);

      const defaultValue : labelType[] = []
      const [ etiquetas_seleccionadas, setEtiquetasSeleccionada ] = useState<any>([])
      const [ etiquetas_seleccionadas_, setEtiquetasSeleccionada_ ] = useState<any>([])



  const [ cargando_, setCargando ] = useState( true )



  const [ arreglo_estatus, setEstatus ] = useState<any>([true,true,true,true,true,true,true,true,true,true])


  const todos = () =>{
    setEstatus([true,true,true,true,true,true,true,true,true,true])
  }
  const ninguno = () =>{
    setEstatus([false,false,false,false,false,false,false,false,false,false])
  }




  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());


  const [startDate_, setStartDate_] = useState(new Date());
  const [endDate_, setEndDate_] = useState(new Date());


  const onChangeRango = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    // cargarMiReporte()
  };


  const [ tipo_reporte, setTipoReporte ] = useState<number>(1)



      return (
          <>
            <div className="container-fluid">

              <div className="row justify-content-center">
                <div className="col-8 col-sm-8">

                    <h4>Auditoría de Movimientos de Personal</h4>
                    <hr/>



                    <div className="row">
                        <div className="col">
                          
                            <div className="mb-3">
                                <label className="form-label">Fecha y Hora de la Noticia</label>

                              <DatePicker
                              className="form-control"
                                onChange={onChangeRango}
                                startDate={startDate}
                                endDate={endDate}
                                selectsRange
                                dateFormat="dd-MMM-yyyy"
                              />
                            </div>



                        </div>
                        <div className="col-sm-8">
                          

                        <div className="mb-3">
                          <label className="form-label">Filtro por Sucursal</label>

                              <div className="hstack gap-3">

                                  <Select
                                    isMulti
                                    defaultValue={defaultValue}
                                    onChange={(opt:any,e:any)=>{ setEtiquetasSeleccionada(opt) }}
                                    isClearable={true}
                                    name="colors"
                                    options={sucursales}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                  />
                                                     

                                <button type="button" onClick={(e:any)=>{cargarMiReporte()}} className="btn btn-secondary">Cargar</button>
                              </div>

                        </div>


                        </div>
                    </div>





                    <div className="mb-3">
                        <label className="form-label">Tipo de Reporte</label>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" id="inlineCheckbox1" checked={tipo_reporte===1} onChange={(e:any)=>{setTipoReporte(1)}} />
                          <label className="form-check-label" htmlFor="inlineCheckbox1">Reporte por Tipo de Movimiento </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" id="inlineCheckbox2" checked={tipo_reporte===2} onChange={(e:any)=>{setTipoReporte(2)}} />
                          <label className="form-check-label" htmlFor="inlineCheckbox2">Reporte por Empleado</label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" id="inlineCheckbox3" checked={tipo_reporte===3} onChange={(e:any)=>{setTipoReporte(3)}} />
                          <label className="form-check-label" htmlFor="inlineCheckbox3">Listado de Movimientos</label>
                        </div>
                    </div>





                {
                  !cargando_ && (
                      <>




                          
                            {
                              // JSON.stringify(reporte)
                            }


                            {
                              tipo_reporte === 1 && (
                                <>


                                                <table className="table table-hover">
                                                  <thead style={{fontSize:10}}>
                                                    <tr>
                                                      <th className="text-left" scope="col">Tipo de Movimiento</th>
                                                      <th className="text-center" scope="col">Cantidad</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {
                                                      reporte.acumulado_tipo_movimiento.map((sucursal:any)=>
                                                              <tr key={ Math.random().toString(36).substr(2, 9) }>
                                                                <td >
                                                                  <p className="nm">{labelTipoReporteAuditoria(sucursal.tipo_movimiento)}</p>
                                                                </td>
                                                                <td className="text-center" style={{width:80}}>
                                                                  <p className="nm"><small>{sucursal.total}</small></p>
                                                                </td>
                                                              </tr>
                                                        )
                                                    }

                                                  </tbody>
                                                </table>




                                </>
                              )
                            }



                              

                            {
                              tipo_reporte === 2 && (
                                <>
                                  {
                                    // JSON.stringify(reporte.acumulado_empleados)
                                  }


                                                <table className="table table-hover">
                                                  <thead style={{fontSize:10}}>
                                                    <tr>
                                                      <th className="text-left" scope="col">Empleado</th>
                                                      <th className="text-center" scope="col">Sucursal</th>
                                                      <th className="text-center" scope="col">Movimientos</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {
                                                      reporte.acumulado_empleados.map((empleado:any)=>
                                                              <tr key={ Math.random().toString(36).substr(2, 9) }>
                                                                <td >
                                                                  <p className="nm"><b>{empleado.nombres}</b> {empleado.paterno} {empleado.materno}</p>
                                                                </td>
                                                                <td className="text-left" style={{width:400}}>
                                                                  <p className="nm"><small>{empleado.nombre_sucursal}</small></p>
                                                                </td>
                                                                <td className="text-center" style={{width:120}}>
                                                                  <p className="nm"><small>{empleado.total}</small></p>
                                                                </td>
                                                              </tr>
                                                        )
                                                    }

                                                  </tbody>
                                                </table>



                                </>
                              )
                            }



                              

                            {
                              tipo_reporte === 3 && (
                                <>
                                  {
                                    // JSON.stringify(reporte.listado_movimientos_empleados)
                                  }

                                                <table className="table table-hover">
                                                  <thead style={{fontSize:10}}>
                                                    <tr>
                                                      <th className="text-left" scope="col">Empleado</th>
                                                      <th className="text-center" scope="col">Sucursal</th>
                                                      <th className="text-center" scope="col">Tipo</th>
                                                      <th className="text-center" scope="col">Fecha</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {
                                                      reporte.listado_movimientos_empleados.map((empleado:any)=>
                                                              <tr key={ Math.random().toString(36).substr(2, 9) }>
                                                                <td className="v" >
                                                                  <p className="nm"><b>{empleado.nombres}</b> {empleado.paterno} {empleado.materno}</p>
                                                                </td>
                                                                <td className="text-left v" style={{width:400}}>
                                                                  <p className="nm"><small>{empleado.nombre_sucursal}</small></p>
                                                                </td>
                                                                <td className="text-left v" style={{width:300}}>
                                                                  <p className="nm"><small>{labelTipoReporteAuditoria(empleado.tipo_movimiento)}</small></p>
                                                                {
                                                                  empleado.tipo_movimiento !== 'CAMBIO_INFORMACION_PERSONAL' && (
                                                                      <small className="nm"><b>{(empleado.detalles)}</b></small>
                                                                  )
                                                                }
                                                                </td>
                                                                <td className="text-center v" style={{width:200}}>
                                                                  <p className="nm"><small>{empleado.fecha_creacion}</small></p>
                                                                </td>
                                                              </tr>
                                                        )
                                                    }

                                                  </tbody>
                                                </table>





                                </>
                              )
                            }



                      </>
                    )
                }





                    
                </div>
              </div>

            </div>


          </>

      );
  

}

export default ReportesPersonal
